import React, { ChangeEvent, InputHTMLAttributes } from "react";

export function InputCheckBox(props: InputCheckBoxParams) {
    const { label, handleCheckBoxChanged, ...rest } = props;

    return (
        <label className="check_box">
            <input 
                type="checkbox" 
                onChange={(e: ChangeEvent<HTMLInputElement>) => { handleCheckBoxChanged(e.target.checked); }} 
                {...rest}
            />
            <span className="icon_checked"/>
            {label}
        </label>
    );
}

export interface InputCheckBoxParams extends InputHTMLAttributes<HTMLInputElement> {
    label: string,
    handleCheckBoxChanged: (checked: boolean) => void
}
